import { Box, Heading, Container, FormControl, FormLabel, Input, SimpleGrid, Textarea, Checkbox, ButtonGroup, Button, Select, FormErrorMessage, Text, Divider } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import Layout from "scenes/layouts";
import LoadingScreen from "components/loading-screen";
import { Field, Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import AuthorService from "services/authors/author-service";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ProgramService from "services/programs/program-service";

const formInitialValue = {
    title: '',
    subTitle: '',
    isAllowForPublic: false,
    sequence: 0
};

const modules = {
    toolbar: [
        [{ 'header': [1, 2, 3, 4, 5, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'align': [] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
        ['link', 'image', 'video'],
        ['clean']
    ],
    clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: false
    },
    imageResize: {
        parchment: ReactQuill.Quill.import('parchment'),
        modules: ['Resize', 'DisplaySize']
    },
    //blotFormatter: { }
};

const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video', 'align', 'color', 'background'
]

const EditProgramLessonScene = (): ReactElement => {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState<boolean>(true);
    const [isSaving, setSaving] = useState<boolean>(false);
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [lesson, setLesson] = useState<any>(null);
    const [lessonGroup, setLessonGroup] = useState<any>(null);
    const [overview, setOverview] = useState('');
    const { programId, lessonGroupId, lessonId }: any = useParams();

    useEffect(() => {
        setLoading(true);
        ProgramService.GetLessonGroup(programId, lessonGroupId).then((res: any) => {
            setLessonGroup(res.result);
            ProgramService.GetLesson(programId, lessonId).then((resLesson: any) => {
                setLesson(resLesson.result);
                setFormValue(resLesson.result);

                setOverview(resLesson.result.description);
            }).finally(() => {
                setLoading(false);
            });
        });
    }, []);

    const handleFormSubmit = (values: any) => {
        setSaving(true);
        ProgramService.UpdateLesson(programId, lessonGroupId, lessonId, values.title, values.subTitle, overview, values.isAllowForPublic, values.sequence).then((res: any) => {
            navigate(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${res.result.id}`);
        }).finally(() => {
            setSaving(false);
        })
    };

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Edit Lesson {lesson.title}</Heading>
                </Box>
                <Box mt={6}>
                    <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                        {
                            ({ handleSubmit, errors, touched, setFieldValue, values }) => (
                                <form onSubmit={handleSubmit} noValidate={true}>
                                    <SimpleGrid columns={{ base: 1, md: 2 }}>
                                        <Box py={4} flex={1}>
                                            <Text fontSize={'sm'} color={'gray.500'}>Program</Text>
                                            <Text fontSize={'sm'} fontWeight={'bold'}>{lessonGroup.program.fullName || '-'}</Text>
                                        </Box>
                                        <Box py={4} flex={1}>
                                            <Text fontSize={'sm'} color={'gray.500'}>Group Lesson</Text>
                                            <Text fontSize={'sm'} fontWeight={'bold'}>{lessonGroup.title || '-'}</Text>
                                        </Box>
                                    </SimpleGrid>

                                    <Box px={0} py={2}>
                                        <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                            <FormControl isRequired isInvalid={!!(errors.title && touched.title)}>
                                                <FormLabel htmlFor='name'>Judul</FormLabel>
                                                <Field
                                                    as={Input}
                                                    id='title'
                                                    name={'title'}
                                                    placeholder='Judul Lesson'
                                                    validate={(value: any) => {
                                                        let error;
                                                        if (value.length <= 0) {
                                                            error = "Judul wajib diisi."
                                                        }
                                                        return error;
                                                    }} />
                                                <FormErrorMessage>{errors.title}</FormErrorMessage>
                                            </FormControl>
                                        </SimpleGrid>
                                    </Box>

                                    <Box px={0} py={2}>
                                        <SimpleGrid columns={{ base: 1 }} gap={12}>
                                            <FormControl isRequired isInvalid={!!(errors.subTitle && touched.subTitle)}>
                                                <FormLabel htmlFor='name'>Dekripsi Singkat</FormLabel>
                                                <Field
                                                    as={Textarea}
                                                    id='subTitle'
                                                    name={'subTitle'}
                                                    rows={2}
                                                    placeholder='Penjelasan Singkat tentang program ini'
                                                    validate={(value: any) => {
                                                        let error;
                                                        if (value.length <= 0) {
                                                            error = "Deskripsi wajib diisi."
                                                        }
                                                        if (value.length > 256) {
                                                            error = "Deskripsi tidak boleh lebih dari 256 karakter."
                                                        }
                                                        return error;
                                                    }} />
                                                <FormErrorMessage>{errors.subTitle}</FormErrorMessage>
                                            </FormControl>
                                        </SimpleGrid>
                                    </Box>

                                    <Box px={0} py={2}>
                                        <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                            <FormControl isRequired isInvalid={!!(errors.sequence && touched.sequence)}>
                                                <FormLabel htmlFor='name'>Nomor Urutan</FormLabel>
                                                <Field
                                                    as={Input}
                                                    type={'number'}
                                                    id='sequence'
                                                    name={'sequence'}
                                                    placeholder='Nomor Urutan'
                                                    validate={(value: any) => {
                                                        let error;
                                                        if (value.length <= 0) {
                                                            error = "Nomor Urutan wajib diisi."
                                                        }
                                                        return error;
                                                    }} />
                                                <FormErrorMessage>{errors.sequence}</FormErrorMessage>
                                            </FormControl>
                                        </SimpleGrid>
                                    </Box>

                                    <Box px={0} py={2}>
                                        <SimpleGrid columns={{ base: 1 }} gap={12}>
                                            <FormControl isRequired isInvalid={!!(errors.isAllowForPublic && touched.isAllowForPublic)}>
                                                <FormLabel htmlFor='name'>Publik?</FormLabel>
                                                <Field
                                                    type="checkbox"
                                                    id='isAllowForPublic'
                                                    name={'isAllowForPublic'}
                                                    checked={values.isAllowForPublic}
                                                    style={{ width: '22px', height: '22px' }}
                                                />
                                                <FormErrorMessage>{errors.isAllowForPublic}</FormErrorMessage>
                                            </FormControl>
                                        </SimpleGrid>
                                    </Box>

                                    <Divider my={4} />

                                    <Box px={0} py={4}>
                                        <FormControl>
                                            <FormLabel htmlFor='price'>Overview</FormLabel>
                                            <ReactQuill
                                                theme="snow"
                                                value={overview}
                                                onChange={setOverview}
                                                placeholder="Penjelasan Lesson"
                                                modules={modules}
                                                formats={formats}
                                            />
                                        </FormControl>
                                    </Box>

                                    <Box px={0} py={8}>
                                        <ButtonGroup gap={2}>
                                            <Button type={'submit'} isLoading={isSaving}>Submit</Button>
                                            <Button variant={'outline'} onClick={() => { navigate(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}`) }}>Kembali</Button>
                                        </ButtonGroup>
                                    </Box>
                                </form>
                            )
                        }
                    </Formik>
                </Box>
            </Container>
        </Layout>
    );
};

export default EditProgramLessonScene;